<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "发货单号",
            "code": "no",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "订单号",
            "code": "orderNo",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "买家名称",
            "code": "buyerName",
            "basic": true
        }, {
            "type": "Text",
            "label": "买家业务单元",
            "code": "buyerShopName",
            "basic": true
        }, {
            "type": "Text",
            "label": "买家所属部门",
            "code": "buyerBizUnitName",
            "basic": true
        }, {
            "type": "Text",
            "label": "物流单号",
            "code": "logisExpNo",
            "basic": true
        }, {
            "type": "Select",
            "label": "状态",
            "code": "state",
            "dataList": [{
                "value": null,
                "label": "- 全部 -"
            }, {
                "value": "partRecv",
                "label": "已部分收货"
            }, {
                "value": "allRecv",
                "label": "已全部收货"
            }, {
                "value": "shiped",
                "label": "已发货"
            }, {
                "value": "toShip",
                "label": "未发货"
            }, {
                "value": "invalid",
                "label": "已作废"
            }],
            "basic": true
        }, {
            "type": "Text",
            "label": "发货人",
            "code": "senderContactName",
            "basic": true
        }, {
            "type": "Date2",
            "label": "发货确认时间",
            "code": "confirmTime",
            "valueType": "String",
            "basic": true
        }],
        "sortFields": [{
            "label": "发货确认时间",
            "code": "confirmTime",
            "order": "desc",
            "enabled": true
        }]
    };

    export default {
        name: 'swb-goods-ship-voucher-search',
        desc: '发货管理搜索',
        data: function () {
            return {
                //排序、搜索
                queryConfig: null,
                queryKey: null
            }
        },
        created: function () {
            this.initQuery();
        },
        methods: {
            //
            initQuery: function () {
                //----------------------搜索排序----------------------------
                //查询排序配置信息
                let queryConfig = searchConfigData || {};
                //查询回调函数调用上下文对象
                //queryConfig.queryContext = this;
                //
                this.queryConfig = queryConfig;
            },
            //
            queryHandler(queryModel) {
                //缓存查询条件
                this.$emit('showSearch', queryModel);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsShipVoucherSearch.vue